<template>
  <div class="backdrop">
    <div class="flex-column">
      <div class="flex-item">
        <img class="logo" src="@/assets/weavr-logo.svg">
      </div>
      <div class="flex-item">
        <span class="weavr-text">
          Weavr
        </span>
      </div>
      <div class="flex-item">
        <span class="info-message">
          Creating your new team...
        </span>
        <span class="info-message">
          <Spinner color="teal" />
        </span>
        <span class="info-message">
          You'll be redirected shortly!
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Spinner from '@/components/utilComponents/Spinner.vue';

export default Vue.extend({
  name: 'CreateSubscriptionCallbackScreen',
  components: {
    Spinner
  },
  data: () => ({
    stripeCustomerId: null,
    socket: null
  }),
  computed: {
    auth0UserId: function() {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async getStripeCustomerId() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/getstripecustomerid`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });

      this.stripeCustomerId = response.data.stripeCustomerId;

      if (!this.stripeCustomerId) {
        // NOTE: Stripe customer ID should never be undefined here, so there's a backend problem -- send the customer home anyway
        this.goHome();
      }
    },
    async checkUserIsOnTeam() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/checkuserisonteam`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });

      const { isUserOnTeam, isUserLeader } = response.data;

      if (isUserOnTeam && isUserLeader) {
        this.goHome();
      }
    },
    goHome() {
      if (this.socket) {
        this.disconnectSocket();
      }

      this.$router.push({
        name: 'home'
      });
    },
    connectSocket() {
      const newSocket = new WebSocket(`${ process.env.VUE_APP_BACKEND_SOCKET_URL }`);
      newSocket.onopen = () => {
        this.socket = newSocket;
        this.socket.onmessage = (event) => {
          const socketData = JSON.parse(event.data);

          const socketHandlerTable = {
            'subscriptionCreated': () => {
              if (socketData.stripeCustomerId === this.stripeCustomerId) {
                this.goHome();
              }
            }
          };

          if (socketData.code in socketHandlerTable) {
            socketHandlerTable[socketData.code]();
          }
        };

        this.socket.send(JSON.stringify({
          action: 'attachSubscriptionSocket',
          stripeCustomerId: this.stripeCustomerId
        }));
      };
    },
    disconnectSocket() {
      try {
        this.socket.send(JSON.stringify({
          action: 'detachSubscriptionSocket',
          stripeCustomerId: this.stripeCustomerId
        }));

        this.socket.close();
      } catch (error) {
        console.log('Error on socket disconnect:', error);
      }
    }
  },
  created: async function() {
    await this.getStripeCustomerId();
    this.connectSocket();
    await this.checkUserIsOnTeam();
  }
})
</script>

<style scoped lang="scss">
.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.flex-column {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: max-content;
  text-align: center;
  font-size: 1.4em;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
}

.flex-item {
  flex: 0;
  display: flex;
  flex-direction: column;
}

.weavr-text {
  font-size: 1em;
  padding: 0.4em 0;
  margin: 0 auto;
  color: $brand-teal;
}

.logo {
  height: 6em;
  width: 6em;
  margin: 0 auto;
}

.info-message {
  margin: 0 auto;
  font-size: 1.3em;
  padding-top: 1.4em;
}
</style>
